<template>
  <div class="popover-container" :style="[containerStyle]">
    <slot></slot>
    <div :class="['popover-content', [...position]]" :style="[popoverStyle]">
      <div v-if="text" class="d-flex">
        <span class="text">{{ text || "PopOver Text Here" }}</span>
      </div>
      <slot name="text"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    position: {
      type: [String, Array],
      default: "right",
    },
    popoverStyle: Object,
    containerStyle: Object,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.popover-container {
  display: flex;
  position: relative;

  .popover-content {
    display: none;
    position: absolute;
    z-index: 2;
    background-color: #fff;
    padding: 8px;
    border-radius: 6px;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.08);
    width: 180px;

    &.right {
      left: 20px;
    }

    &.left {
      right: 20px;
    }

    &.top {
      bottom: 0;
    }

    .text {
    }
  }

  &:hover {
    .popover-content {
      display: flex;
    }
  }
}
</style>
